export const isSameArray: <T>(a: T[], b: T[]) => boolean = <T>(a: T[], b: T[]): boolean => {
  const aSorted: T[] = [...a].sort();
  const bSorted: T[] = [...b].sort();

  return aSorted.length === bSorted.length && aSorted.every((val: T, i: number): boolean => val === bSorted[i]);
};
